import { InMemoryCache, defaultDataIdFromObject } from '@apollo/client';

const typePolicies = {
  dataIdFromObject: (object) => {
    // eslint-disable-next-line
    switch (object.__typename) {
      case 'Me':
        return object.userId;
      default:
        return defaultDataIdFromObject(object);
    }
  },
  SupplierQueries: {
    fields: {
      getConnectionsForProperty: {
        merge(existing, incoming, { mergeObjects }) {
          return mergeObjects(existing, incoming);
        }
      },
      getPropertyRateAndMarkupLogs: {
        // Custom merge logic for paginated data
        merge(existing, incoming, { mergeObjects }) {
          return mergeObjects(existing, incoming);
        }
      }
    }
  },
  RateAndMarkupLogResponse: {
    fields: {
      logs: {
        merge(existing, incoming, { mergeObjects }) {
          return mergeObjects(existing, incoming);
        }
      }
    }
  },
  RateAndMarkupLog: {
    keyFields: ['username', 'timeStamp'] // Use a combination of fields to uniquely identify logs
  },
  Address: {
    fields: {
      city: {
        merge(existing, incoming, { mergeObjects }) {
          return mergeObjects(existing, incoming);
        }
      },
      region: {
        merge(existing, incoming, { mergeObjects }) {
          return mergeObjects(existing, incoming);
        }
      },
      country: {
        merge(existing, incoming, { mergeObjects }) {
          return mergeObjects(existing, incoming);
        }
      }
    }
  }
};

export const cache = new InMemoryCache({
  typePolicies
});
